import AuthGuard from '@components/AuthGuard';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import TextField from '@components/TextField';
import TextUnderline from '@components/TextUnderline';
import styled from '@emotion/styled';
import { useAtom } from 'jotai';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { queryAtom, isMyShopAtom } from '../../atoms/shopsInMapAtoms';

function ShopFilter() {
    const { t } = useTranslation('shopList');
    const [isMy, setIsMy] = useAtom(isMyShopAtom);
    const [query, setQuery] = useAtom(queryAtom);
    const showHelperText = query !== undefined && query.length === 1;
    useEffect(() => {
        setQuery('');
    }, []);
    return (
        <Container as='section'
            fullWidth
            spacing={4}>
            <Row justify='space-between' fullWidth>
                <TextUnderline>
                    <Text size='title' color='var(--color-text-secondary)'>
                        {t('filter.searchPlaceholder')}
                    </Text>
                </TextUnderline>
                <Row spacing={4}>
                    <Text
                        color={isMy ? 'var(--color-text-unseledcted)' : 'var(--color-text-secondary)'}
                        onClick={() => setIsMy(false)}
                        fontWeight={isMy ? 'regular' : 'bold'}>
                        {t('filter.all')}
                    </Text>
                    <AuthGuard>
                        <Text
                            color={isMy ? 'var(--color-text-secondary)' : 'var(--color-text-unseledcted)'}
                            onClick={() => setIsMy(true)}
                            fontWeight={isMy ? 'bold' : 'regular'}>
                            {t('filter.myShop')}
                        </Text>
                    </AuthGuard>
                </Row>
            </Row>
            <TextField placeholder={t('filter.inputPlaceholder')}
                maxLength={20}
                onChange={(e) => setQuery(e.target.value)}
                helperText={showHelperText ? t('filter.helperText') : ''} />
        </Container>
    );
}

const Container = styled(Column)`
    background-color: var(--color-white);
    padding: var(--spacing-6) var(--spacing-4);
`;

export default ShopFilter;
